import { render, staticRenderFns } from "./ApiEndpoint.vue?vue&type=template&id=36b331bc&"
import script from "./ApiEndpoint.vue?vue&type=script&lang=js&"
export * from "./ApiEndpoint.vue?vue&type=script&lang=js&"
import style0 from "./ApiEndpoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports